import * as ComponentsModule from './components';

const { ...Components } = ComponentsModule;

export {
  Components
}
